import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./UserMenu.module.css";
import { getSessionInfo, logout } from "../../api/userApi";

interface Props {
    onHistoryClick: () => void;
    authVersion?: number;
}

export const UserMenu = ({ onHistoryClick, authVersion }: Props) => {
    const [email, setEmail] = useState<string | null>(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);
    const navigate = useNavigate();

    useEffect(() => {
        getSessionInfo().then(info => {
            if (info) {
                setEmail(info.email);
                setIsAdmin(info.isAdmin);
            }
        });
    }, [authVersion]);

    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) {
                setOpen(false);
            }
        };
        if (open) document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [open]);

    if (!email) return null;

    const handleLogout = async () => {
        await logout();
        window.location.reload();
    };

    return (
        <div className={styles.userMenuContainer} ref={ref}>
            <button className={styles.userButton} onClick={() => setOpen(!open)} aria-label="User menu">
                <span className={styles.userIcon}>&#128100;</span>
                <span className={styles.userEmail}>{email}</span>
                <span className={styles.chevron}>{open ? "▲" : "▼"}</span>
            </button>

            {open && (
                <div className={styles.dropdown}>
                    <div className={styles.dropdownEmail}>{email}</div>
                    <button className={styles.dropdownItem} onClick={() => { setOpen(false); onHistoryClick(); }}>
                        &#128337; Chat History
                    </button>
                    {isAdmin && (
                        <button className={styles.dropdownItem} onClick={() => { setOpen(false); navigate("/admin"); }}>
                            &#9881;&#65039; Admin Dashboard
                        </button>
                    )}
                    <div className={styles.dropdownDivider} />
                    <button className={styles.logoutItem} onClick={handleLogout}>
                        &#x1F6AA; Logout
                    </button>
                </div>
            )}
        </div>
    );
};
